import { ICDNResponseCommand } from "../enums/icd-response-cmd.enum";

export class ICDResponseBaseModel {
  // Required
  public icdId: string;
  public responseCmd: ICDNResponseCommand;
  // Optional
  public data: any;

  // Constructor
  constructor(icdId: string, responseCmd: ICDNResponseCommand, data?: any) {
    this.icdId = icdId;
    this.responseCmd = responseCmd;
    this.data = data;
  }
}
